import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={25.988}
    height={25.988}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 22185 22184"
    {...props}
  >
    <path
      d="M21585 2432c0-219-267-316-413-171l-750 751c306 306 241 241 341 342l752-751c45-46 70-106 70-171zm-650 1768c-1748-1749-2317-2317-2951-2951l-833 833c351 353 2326 2326 2951 2951l833-833zm-1936 1937-2952-2952L3186 16047l2951 2952L18999 6137zM5799 19336l-2951-2951-428 428 2951 2952 428-429zm-765 766-2951-2951-834 833c994 994 1812 1811 2951 2951l834-833zm-1680 661-341-341-751 751c-95 94-95 247 0 341 91 91 250 91 342 0l750-751zm-1592-1591-341-342-751 751c-94 95-94 247 0 342 94 94 248 94 342 0l750-751zM16385 2848l2951 2951 428-428c-351-352-2325-2326-2951-2951l-428 428zm2446-1427c54 54 287 288 341 341l751-751c45-45 70-106 70-170 0-220-267-316-412-171l-750 751zm3020 1519-750 751 341 341c92 93 93 244 0 337C19540 6270 6428 19382 4368 21441c-92 93-243 93-336 0l-341-340-751 750c-448 448-1226 134-1226-508 0-192 74-372 210-508l751-750-576-576-749 751c-281 280-737 280-1018 0-279-280-279-736 0-1016l751-751-339-341c-95-93-95-244 0-337C4553 14005 9406 9152 17816 743c89-89 247-89 336 0l341 340 751-750c450-450 1226-130 1226 508 0 192-74 372-210 508l-751 751 576 575 750-751c281-281 736-281 1016 0 281 281 281 735 0 1016z"
      style={{
        fill: "#2b2a29",
        // stroke: "#000",
        strokeWidth: 245.847,
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
